import { useState, useRef, useEffect } from "react";
import TextOptionsMenu from "./TextOptionsMenu";
import { MenuSVG } from "./SVG";
const EditableText = ({
  text,
  onTextChange,
  style,
  className,
  font,
  color,
  fontSize = 16,
  isBold,
  isItalic,
  onStyleChange,
  tag = "p",
  isEditable,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [optionsPosition, setOptionsPosition] = useState({ left: 0, top: 0 });
  const [localText, setLocalText] = useState(text);
  const editRef = useRef(null);
  const optionsRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    setLocalText(text);
  }, [text]);

  useEffect(() => {
    if (isEditing && editRef.current) {
      editRef.current.focus();
    }
  }, [isEditing]);

  const handleButtonClick = () => {
    if (!buttonRef.current) return;

    const rect = buttonRef.current.getBoundingClientRect();
    setOptionsPosition({
      top: rect.bottom + 25,
      left: window.innerWidth / 2,
    });

    setShowOptions((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showOptions &&
        optionsRef.current &&
        !optionsRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showOptions]);

  const handleBlur = () => {
    setIsEditing(false);
    const newText = editRef.current.textContent.trim();
    if (newText !== text) {
      onTextChange(newText);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const newText = editRef.current.textContent.trim();
      if (newText !== text) {
        onTextChange(newText);
      }
      editRef.current.blur();
    }
  };

  const handleInput = (e) => {
    setLocalText(e.target.textContent);
  };

  const Tag = tag;

  return (
    <div className="group relative">
      <Tag
        ref={editRef}
        contentEditable={isEditing}
        onBlur={handleBlur}
        onClick={() => isEditable && setIsEditing(true)}
        onKeyDown={handleKeyDown}
        style={{
          ...style,
          fontSize: `${fontSize}px`,
          color,
          fontWeight: isBold ? "bold" : "normal",
          fontStyle: isItalic ? "italic" : "normal",
        }}
        className={`outline-none ${className} ${
          isEditing ? "ring-2 ring-teal-500" : ""
        } ${
          isEditable && !isEditing && "border-2 border-dashed border-gray-200"
        }`}
        suppressContentEditableWarning={true}
      >
        {text}
      </Tag>

      {isEditable && (
        <button
          type="button"
          ref={buttonRef}
          onClick={handleButtonClick}
          className="absolute -right-8 top-0 opacity-0 group-hover:opacity-100 transition-opacity bg-teal-600 rounded-full"
        >
          <MenuSVG />
        </button>
      )}

      {showOptions && (
        <div
          ref={optionsRef}
          className="fixed bg-white rounded-xl shadow-lg ring-1 ring-black ring-opacity-5 z-50 transform -translate-x-1/2"
          style={{
            left: `${optionsPosition.left}px`,
            top: `${optionsPosition.top}px`,
          }}
        >
          <TextOptionsMenu
            font={font}
            color={color}
            fontSize={fontSize}
            isBold={isBold}
            isItalic={isItalic}
            onStyleChange={onStyleChange}
          />
        </div>
      )}
    </div>
  );
};

export default EditableText;
